import React, { useState } from 'react';
import { Avatar } from '@material-ui/core';
import { makeStyles, Tooltip } from '@material-ui/core/';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import { useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
	sourceAvatar: {
		// height: '3em',
		color: 'black',
		textAlign: 'center',
		fontSize: '1rem',
		'& img': {
			objectFit: 'fill',
		},
		backgroundColor: '#E5E5E5',
	},
}));

function ImageErrorAvatar({ imgUrl, toolTipMsg }) {
	const classes = useStyles();
	const [titleMsg, settitleMsg] = useState('');
	// only render toolTip error message when image loading fails.
	const AltText = () => {
		useEffect(() => {
			settitleMsg(toolTipMsg);
		});
		return (
			<>
				<ReportProblemIcon color="error" /> Image Error
			</>
		);
	};
	return (
		<Tooltip title={titleMsg} arrow={true} placement="top">
			<Avatar src={imgUrl} variant="square" className={classes.sourceAvatar}>
				<AltText />
			</Avatar>
		</Tooltip>
	);
}

export default ImageErrorAvatar;
